<template>
  <v-autocomplete
    outlined
    v-model="selected"
    :items="channels"
    item-text="channel"
    item-value="id"
    :menu-props="{ maxHeight: '400', zIndex: 13 }"
    label="Sélectionner les channels"
    multiple
    small-chips
    deletable-chips
  ></v-autocomplete>
</template>

<script>
import { computed, onMounted, watch } from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "ChannelFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    // =>  METHODS

    // =>  COMPUTED
    const selected = computed({
      get: () => store.getters["audience/getChannels"],
      set(e) {
        store.dispatch("audience/updateChannels", e);
      },
    });

    const channels = computed(() => store.getters["audience/getChannelList"]);

    // =>  WATCH
    watch(selected, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        is_multiple: true,
        is_integer: true,
        // is_boolean: false,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      await store.dispatch("audience/getChannelList");

      await synchronizeFilterWithQueryString({
        dispatcher: "audience/updateChannels",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: selected.value,
        is_multiple: true,
        is_integer: true,
        // is_boolean: false,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      channels,
      selected,
    };
  },
};
</script>

<style scoped>
[role="menu"] {
  top: 233px !important;
  right: 0 !important;
}
</style>
